<ng-scrollbar visibility="hover" [style.height]="scrollHeight">
  <cdk-virtual-scroll-viewport [itemSize]="32" ngScrollbarView smoothScroll scrollViewport>
    <div
      *cdkVirtualFor="let item of subordinateItems; let i = index"
      class="hierarchy-subordinate-item"
      [ngClass]="{ selected: i === selectedIndex }"
      (click)="onSelectItem(item, i)"
    >
      <avatar
        *ngIf="item?.icon"
        class="hierarchy-subordinate-item-avatar"
        [url]="item?.icon"
        [fallback]="item?.fallbackIcon"
        [size]="'24px'"
      ></avatar>
      <span *ngIf="item?.title" class="hierarchy-subordinate-item-text">{{ item?.title }}</span>
    </div>
  </cdk-virtual-scroll-viewport>
</ng-scrollbar>
